import React from 'react'
import AroPMISScreenshot from '../../images/AroPMIS.png'

const AroPMIS = () => (
  <section id='aropmis' className='section aropmis'>
    <div className='container'>
      <div className='section-header'>
        <h2>AroPMIS - Property Management Information System</h2>
        <p>
          Our flagship product designed to revolutionize property management
          operations.
        </p>
      </div>

      <div className='aropmis-content'>
        <div className='aropmis-text'>
          <h3>Streamline Your Property Management</h3>
          <p>
            AroPMIS is a comprehensive Property Management Information System{' '}
            <br />
            that simplifies and automates all aspects of property management.
          </p>
          <ul class='features-list'>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Tenant and lease management with automated reminders</span>
            </li>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Rent collection and financial reporting</span>
            </li>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Maintenance request tracking and resolution</span>
            </li>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Property portfolio performance analytics</span>
            </li>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Document storage and management</span>
            </li>
            <li>
              <i class='fas fa-check'></i>{' '}
              <span>Mobile-friendly interface for on-the-go management</span>
            </li>
          </ul>
          <a href='#contact' className='btn btn-accent'>
            Request A Demo
          </a>
        </div>
        <div className='aropmis-image'>
          <img src={AroPMISScreenshot} alt='Working screenshot' />
        </div>
      </div>
    </div>
  </section>
)

export default AroPMIS
